<template>
  <div>
    <b-tooltip
      :label="
        this.sondage_vue_resultats === 'all'
          ? $t('button.SeeSlider')
          : $t('button.SeeAllChart')
      "
      position="is-left"
    >
      <img
        v-if="this.sondage_vue_resultats !== 'all'"
        @click="viewFunction()"
        style="width:16px;margin-right:10px;cursor:pointer"
        src="@/assets/img/icons/list.png"
        alt="full-screen-icon"
      />
      <img
        v-else
        @click="viewFunction()"
        style="width:16px;margin-right:10px;cursor:pointer"
        src="@/assets/img/icons/diaporama.png"
        alt="full-screen-icon"
      />
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ButtonDiaporama',
  computed: {
    ...mapGetters(['sondage_vue_resultats'])
  },
  methods: {
    viewFunction () {
      if (this.sondage_vue_resultats === 'all') {
        this.vueSlider()
      } else if (this.sondage_vue_resultats === 'slider') {
        this.vueAll()
      }
    },
    ...mapMutations({
      vueAll: 'SET_VUE_RESULTATS_ALL',
      vueSlider: 'SET_VUE_RESULTATS_SLIDER'
    })
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/resultats/components/ButtonDiaporama.vue